<template>
  <div class="hospital-stats-page">
    <div class="loading-mask" v-if="showLoading">
      <van-loading type="spinner" />数据加载中...
    </div>

    <!-- 今日数据统计区 -->
    <div class="top-stats">
      <div class="stat-card">
        <div class="card-icon">
          <i class="fa fa-child"></i>
        </div>
        <p class="stat-value">{{ todayScreenTotal }}</p>
        <p class="stat-label">今日筛查总量</p>
      </div>
      <div class="stat-card">
        <div class="card-icon">
          <i class="fa fa-hospital-o" style="color: #5CC4AB;"></i>
        </div>
        <p class="stat-value">{{ todayFileTotal }}</p>
        <p class="stat-label">今日建档总量</p>
      </div>
    </div>

    
    <div class="section-b">
      <h3 style="text-align: left;">医院数据查询</h3>

      <!-- <div class="section-b">
        <div class="date-picker">
          <input 
            v-model="selectedDate" 
            readonly 
            clickable 
            placeholder="请选择日期" 
            @click="showDatePicker = true"
            class="input-common date-input"  
          />
        </div>
      </div> -->
      <div class="section-data">
        <div class="date-picker-group">
          <!-- 开始日期 -->
          <div class="date-picker-item">
            <input 
              v-model="selectStartDate" 
              readonly 
              clickable 
              placeholder="开始日期" 
              @click="showStartDatePicker = true"
              class="input-common date-input"  
            />
          </div>
          
          <!-- 分隔符 -->
          <div class="date-separator">至</div>
          
          <!-- 结束日期 -->
          <div class="date-picker-item">
            <input 
              v-model="selectEndDate" 
              readonly 
              clickable 
              placeholder="结束日期" 
              @click="showEndDatePicker = true"
              class="input-common date-input"  
            />
          </div>
        </div>
      </div>


      <!-- 医院搜索选择组件 -->
      <div class="hospital-select">
        <van-field
            readonly
            clickable
            placeholder="请选择医院"
            :value="selectedHospitalName"
            @click="showHospitalPopup = true"
            style="padding: 8px; border: 1px solid #e5e7eb; border-radius: 8px; height: 35px; margin-right: 10px; line-height: 14px; flex: 1;"
        />
        <div class="search-button-item">
          <button class="search-btn" style="flex:1" @click="handleSearch">
            查询
          </button>
        </div>
        <!-- <button class="search-btn" @click="handleSearch">查询</button> -->
        
        
      </div>

      <!-- 并排展示的结果框 -->
      <div class="result-boxes">
        <div class="result-box school-box">
          <p class="box-title">入校筛查量</p>
          <p class="box-value">{{ schoolScreenCount }}</p>
        </div>
        <div class="result-box hospital-box">
          <p class="box-title">医院建档量</p>
          <p class="box-value">{{ hospitalFileCount }}</p>
        </div>
      </div>
      <div class="result-boxes">
        <div class="result-box school-box">
          <p class="box-title">订单金额</p>
          <p class="box-value">{{ orderAmount }}</p>
        </div>
        <div class="result-box hospital-box">
          <p class="box-title">订单数量</p>
          <p class="box-value">{{ orderCount }}</p>
        </div>
      </div>
      <!-- 医院选择弹出层 -->
      <van-popup v-model="showHospitalPopup" position="bottom" style="height: 70%">
          <div class="hospital-popup">
          <!-- 顶部搜索栏 -->
          <div class="search-header">
              <van-search
              v-model="hospitalSearchKey"
              placeholder="搜索医院名称"
              @search="filterHospitals"
              @input="filterHospitals"
              class="hospital-search-van"
              />
              <van-button text="取消" class="cancel-btn-van" @click="showHospitalPopup = false" />
          </div>
          
          <!-- 搜索结果列表                     :title="highlightKeyword(hospital.lable)" -->
          <div class="hospital-list">
              <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多数据"
              @load="loadMoreHospitals"
              >
              <van-cell
                  v-for="hospital in filteredHospitals"
                  :key="hospital.value"
                  :title="highlightKeyword(hospital.label)"
                  @click="selectHospital(hospital)"
                  clickable
              />
              </van-list>
              
              <!-- 无结果提示 -->
              <van-empty 
              v-show="!loading && filteredHospitals.length === 0" 
              description="没有找到匹配的医院" 
              image="search"
              />
          </div>
          </div>
      </van-popup>
    </div>



   <!-- 底部 Tab 切换区 -->
    <div class="section-b">
    <div class="tab-bar">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab-item"
        :class="{ active: currentTab === tab.key }"
        @click="switchTab(tab.key)"
      >
        <span>{{ tab.title }}</span>
      </div>
    </div>

    <!-- Tab 内容区 -->
    <div class="tab-content">
      
      <div v-show="currentTab === 'school'">

        <div class="section-data">
          <div class="date-picker-group">
            <!-- 开始日期 -->
            <div class="date-picker-item">
              <input 
                v-model="selectStartDate2" 
                readonly 
                clickable 
                placeholder="开始日期" 
                @click="showStartDatePicker2 = true"
                class="input-common-min date-input"  
              />
            </div>
            <!-- 结束日期 -->
            <div class="date-picker-item">
              <input 
                v-model="selectEndDate2" 
                readonly 
                clickable 
                placeholder="结束日期" 
                @click="showEndDatePicker2 = true"
                class="input-common-min date-input"  
              />
            </div>
            <div class="search-button-item">
              <button class="search-button" @click="loadTabData">
                查询
              </button>
            </div>
          </div>
        </div>


        <!-- 学校搜索框 -->
        <div class="search-container">
          <van-search
            v-model="schoolSearchKey"
            placeholder="搜索医院名称"
            @search="filterSchoolList"
            @input="filterSchoolList"
            style="padding: 8px 0px;border-radius: 8px;"
          />
        </div>

        <!-- 新增表头 -->
        <div class="rank-header" v-show="currentTab === 'school'">
          <div class="rank">排名</div>
          <div class="name">医院名称</div>
          <div class="number">入校筛查量</div>
        </div>
        
        <div class="rank-list">
          <div
            v-for="(item, idx) in displayFilteredSchoolList"
            :key="idx"
            class="rank-item"
          >
            <div class="rank">
              <div :class="{'rank-icon': true, 'top-three': idx < 3, 'normal': idx >= 3}">{{ idx + 1 }}</div>
            </div>

            <div class="name">{{ item.name }}</div>
            <div class="number">{{ item.totalNumber }}</div>
          </div>
        </div>
        
        <van-empty 
          v-if="filteredSchoolList.length === 0 && !loadingSchool" 
          description="暂无数据" 
          image="search" 
        />
        
        <button 
          v-if="filteredSchoolList.length > 15 && !showAllSchool" 
          class="load-more-btn" 
          @click="loadAllSchoolData"
        >
          加载更多 <i class="fa fa-angle-down"></i>
        </button>
      </div>
      
      <div v-show="currentTab === 'hospital'">
        <div class="section-data">
          <div class="date-picker-group">
            <!-- 开始日期 -->
            <div class="date-picker-item">
              <input 
                v-model="selectStartDate2" 
                readonly 
                clickable 
                placeholder="开始日期" 
                @click="showStartDatePicker2 = true"
                class="input-common-min date-input"  
              />
            </div>
            <!-- 结束日期 -->
            <div class="date-picker-item">
              <input 
                v-model="selectEndDate2" 
                readonly 
                clickable 
                placeholder="结束日期" 
                @click="showEndDatePicker2 = true"
                class="input-common-min date-input"  
              />
            </div>
            <div class="search-button-item">
              <button class="search-button" @click="loadTabData">
                查询
              </button>
            </div>
          </div>
        </div>
        <!-- 医院搜索框 -->
        <div class="search-container">
          <van-search
            v-model="hospitalSearchKey2"
            placeholder="搜索医院名称"
            @search="filterHospitalList"
            @input="filterHospitalList"
            style="padding: 8px 0px;border-radius: 8px;"
          />
        </div>
		 <div class="mb-6">
		      <select 
		        v-model="dimensionSelectedOption"
		        @change="handleDimensionSelectChange"
		      >
		        <optgroup label="基础人数统计">
		          <option value="0" selected>建档人数</option>
		          <option value="1">成交客户人数</option>
		          <option value="2">成交新客户人数</option>
		          <option value="3">成交客户建档人数</option>
		          <option value="4">添加企微人数</option>
		          <option value="5">添加企微并绑定档案人数</option>
		        </optgroup>
		        <optgroup label="16岁以下专项">
		          <option value="11">16岁以下建档人数</option>
		          <option value="12">16岁以下成交客户人数</option>
		          <option value="13">16岁以下成交新客户人数</option>
		          <option value="14">16岁以下成交客户建档人数</option>
		          <option value="15">16岁以下添加企微并绑定档案人数</option>
		        </optgroup>
		      </select>
		</div>

        <div class="rank-header" v-show="currentTab === 'hospital'">
          <div class="rank">排名</div>
          <div class="name">医院名称</div>
          <div class="number">数量</div>
        </div>
        
        <div class="rank-list">
          <div
            v-for="(item, idx) in displayFilteredHospitalList"
            :key="idx"
            class="rank-item"
          >
          <div class="rank">
            <div :class="{'rank-icon': true, 'top-three': idx < 3, 'normal': idx >= 3}">{{ idx + 1 }}</div>
          </div>

            <div class="name">{{ item.name }}</div>
            <div class="number">{{ item.totalNumber }}</div>
          </div>
        </div>
        
        <van-empty 
          v-if="filteredHospitalList.length === 0 && !loadingHospital" 
          description="暂无数据" 
          image="search" 
        />
        
        <button 
          v-if="filteredHospitalList.length > 15 && !showAllHospital" 
          class="load-more-btn" 
          @click="loadAllHospitalData"
        >
          加载更多 <i class="fa fa-angle-down"></i>
        </button>
      </div>
	  
	  <div v-show="currentTab === 'aiChat'">
	      <div class="section-data">
	        <div class="date-picker-group">
	          <!-- 开始日期 -->
	            <div class="date-picker-item">
	              <input 
	                v-model="selectStartDate2" 
	                readonly 
	                clickable 
	                placeholder="开始日期" 
	                @click="showStartDatePicker2 = true"
	                class="input-common-min date-input"  
	              />
	            </div>
	            <!-- 结束日期 -->
	            <div class="date-picker-item">
	              <input 
	                v-model="selectEndDate2" 
	                readonly 
	                clickable 
	                placeholder="结束日期" 
	                @click="showEndDatePicker2 = true"
	                class="input-common-min date-input"  
	              />
	            </div>
	            <div class="search-button-item">
	              <button class="search-button" @click="loadTabData">
	                查询
	              </button>
	            </div>
	          </div>
	      </div>
	      <!-- 医院搜索框 -->
	      <div class="search-container">
	        <van-search
	          v-model="aiSearchKey"
	          placeholder="搜索医院名称"
	          @search="filterAIChatList"
	          @input="filterAIChatList"
			  @clear="clearAISearchKey"
	          style="padding: 8px 0px;border-radius: 8px;"
	        />
	      </div>
	  
	      <div class="rank-header" v-show="currentTab === 'aiChat'">
	        <div class="rank">排名</div>
	        <div class="name">医院名称</div>
			<div class="userCount">人数</div>
	        <div class="number">咨询数量</div>
	      </div>
	      
	      <div class="rank-list">
	        <div
	          v-for="(item, idx) in displayFilteredAIChatList"
	          :key="idx"
	          class="rank-item"
	        >
	        <div class="rank">
	          <div :class="{'rank-icon': true, 'top-three': idx < 3, 'normal': idx >= 3}">{{ idx + 1 }}</div>
	        </div>
	  
	          <div class="name">{{ item.name }}</div>
			  <div class="userCount">{{ item.userCount }}</div>
	          <div class="number">{{ item.totalNumber }}</div>
	        </div>
	      </div>
	      
	      <van-empty 
	        v-if="filteredAIChatList.length === 0 && !loadingAIChat" 
	        description="暂无数据" 
	        image="search" 
	      />
	      
	      <button 
	        v-if="filteredAIChatList.length > 15 && !showAllAIChat" 
	        class="load-more-btn" 
	        @click="loadAllAIChatData"
	      >
	        加载更多 <i class="fa fa-angle-down"></i>
	      </button>
	  </div>

	  <div v-show="currentTab === 'orderCount'">
	      <div class="section-data">
	        <div class="date-picker-group">
	          <div class="date-picker-item">
	            <input 
	              v-model="selectStartDate2" 
	              readonly 
	              clickable 
	              placeholder="开始日期" 
	              @click="showStartDatePicker2 = true"
	              class="input-common-min date-input"  
	            />
	          </div>
	          <div class="date-picker-item">
	            <input 
	              v-model="selectEndDate2" 
	              readonly 
	              clickable 
	              placeholder="结束日期" 
	              @click="showEndDatePicker2 = true"
	              class="input-common-min date-input"  
	            />
	          </div>
	          <div class="search-button-item">
	            <button class="search-button" @click="loadTabData">
	              查询
	            </button>
	          </div>
	        </div>
	      </div>
	      <div class="search-container">
	        <van-search
	          v-model="orderCountSearchKey"
	          placeholder="搜索医院名称"
	          @search="filterOrderCountList"
	          @input="filterOrderCountList"
	          style="padding: 8px 0px;border-radius: 8px;"
	        />
	      </div>
	  
	      <div class="rank-header" v-show="currentTab === 'orderCount'">
	        <div class="rank">排名</div>
	        <div class="name">医院名称</div>
	        <div class="number">订单数量</div>
	      </div>
	      
	      <div class="rank-list">
	        <div
	          v-for="(item, idx) in displayFilteredOrderCountList"
	          :key="idx"
	          class="rank-item"
	        >
	        <div class="rank">
	          <div :class="{'rank-icon': true, 'top-three': idx < 3, 'normal': idx >= 3}">{{ idx + 1 }}</div>
	        </div>
	  
	          <div class="name">{{ item.name }}</div>
	          <div class="number">{{ item.totalNumber }}</div>
	        </div>
	      </div>
	      
	      <van-empty 
	        v-if="filteredOrderCountList.length === 0 && !loadingOrderCount" 
	        description="暂无数据" 
	        image="search" 
	      />
	      
	      <button 
	        v-if="filteredOrderCountList.length > 15 && !showAllOrderCount" 
	        class="load-more-btn" 
	        @click="loadAllOrderCountData"
	      >
	        加载更多 <i class="fa fa-angle-down"></i>
	      </button>
	  </div>

	  <div v-show="currentTab === 'orderAmount'">
	      <div class="section-data">
	        <div class="date-picker-group">
	          <div class="date-picker-item">
	            <input 
	              v-model="selectStartDate2" 
	              readonly 
	              clickable 
	              placeholder="开始日期" 
	              @click="showStartDatePicker2 = true"
	              class="input-common-min date-input"  
	            />
	          </div>
	          <div class="date-picker-item">
	            <input 
	              v-model="selectEndDate2" 
	              readonly 
	              clickable 
	              placeholder="结束日期" 
	              @click="showEndDatePicker2 = true"
	              class="input-common-min date-input"  
	            />
	          </div>
	          <div class="search-button-item">
	            <button class="search-button" @click="loadTabData">
	              查询
	            </button>
	          </div>
	        </div>
	      </div>
	      <div class="search-container">
	        <van-search
	          v-model="orderAmountSearchKey"
	          placeholder="搜索医院名称"
	          @search="filterOrderAmountList"
	          @input="filterOrderAmountList"
	          style="padding: 8px 0px;border-radius: 8px;"
	        />
	      </div>
	  
	      <div class="rank-header" v-show="currentTab === 'orderAmount'">
	        <div class="rank">排名</div>
	        <div class="name">医院名称</div>
	        <div class="number">订单金额</div>
	      </div>
	      
	      <div class="rank-list">
	        <div
	          v-for="(item, idx) in displayFilteredOrderAmountList"
	          :key="idx"
	          class="rank-item"
	        >
	        <div class="rank">
	          <div :class="{'rank-icon': true, 'top-three': idx < 3, 'normal': idx >= 3}">{{ idx + 1 }}</div>
	        </div>
	  
	          <div class="name">{{ item.name }}</div>
	          <div class="number">{{ item.totalNumber }}</div>
	        </div>
	      </div>
	      
	      <van-empty 
	        v-if="filteredOrderAmountList.length === 0 && !loadingOrderAmount" 
	        description="暂无数据" 
	        image="search" 
	      />
	      
	      <button 
	        v-if="filteredOrderAmountList.length > 15 && !showAllOrderAmount" 
	        class="load-more-btn" 
	        @click="loadAllOrderAmountData"
	      >
	        加载更多 <i class="fa fa-angle-down"></i>
	      </button>
	  </div>
    </div>
    </div>
	
	
	<div class="section-b">
	  <h3 style="text-align: left;">海报数据查询</h3>
	  <div class="section-data">
	    <div class="date-picker-group">
	      <!-- 开始日期 -->
	      <div class="date-picker-item">
	        <input 
	          v-model="selectPosterStartDate" 
	          readonly 
	          clickable 
	          placeholder="开始日期" 
	          @click="showPosterStartDatePicker = true"
	          class="input-common-min date-input"  
	        />
	      </div>
	      
	      <!-- 分隔符 -->
	      <div class="date-separator">至</div>
	      
	      <!-- 结束日期 -->
	      <div class="date-picker-item">
	        <input 
	          v-model="selectPosterEndDate" 
	          readonly 
	          clickable 
	          placeholder="结束日期" 
	          @click="showPosterEndDatePicker = true"
	          class="input-common-min date-input"  
	        />
	      </div>
		  <div class="search-button-item">
			<button class="search-button" style="margin: 10px 0 10px 0;" @click="handlePosterSearch(false)">查询</button>
		  </div>
	    </div>
		
		  <div class="rank-header">
		    <div class="rank">排名</div>
		    <div class="name">昵称</div>
			<div class="name">医院名称</div>
		    <div class="number">生成数量</div>
		  </div>
		  
		  <div class="rank-list">
		    <div
		      v-for="(item, idx) in posterUseStatisticList"
		      :key="idx"
		      class="rank-item"
		    >
		    <div class="rank">
		      <div :class="{'rank-icon': true, 'top-three': idx < 3, 'normal': idx >= 3}">{{ idx + 1 }}</div>
		    </div>
		      <div class="name" style="text-align: center;" >{{ item.username }}</div>
			  <div class="name" style="text-align: center;" >{{ item.hospitalName }}</div>
		      <div class="number">{{ item.usage_count }}</div>
		    </div>
		  </div>
		  
		  <van-empty 
		    v-if="posterUseStatisticList.length === 0 && !loadingPoster" 
		    description="暂无数据" 
		    image="search" 
		  />
		  
		  <button 
		    v-if="posterUseStatisticList.length > 9 && !showAllPoster" 
		    class="load-more-btn" 
		    @click="loadMorePosterData"
		  >
		    加载更多 <i class="fa fa-angle-down"></i>
		  </button>
	  </div>
	
	  <!-- 并排展示的结果框 -->
	<!--  <div class="result-boxes">
	    <div class="result-box school-box">
	      <p class="box-title">入校筛查量</p>
	      <p class="box-value">{{ schoolScreenCount }}</p>
	    </div>
	    <div class="result-box hospital-box">
	      <p class="box-title">医院建档量</p>
	      <p class="box-value">{{ hospitalFileCount }}</p>
	    </div>
	  </div> -->
	  
	 
	</div>
	
	


    <!-- 日期选择弹出层 -->
    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker 
        :min-date="minDate" 
        :max-date="maxDate" 
        v-model="currentDate" 
        type="date" 
        @cancel="showDatePicker = false"
        @confirm="onConfirmDate" 
      />
    </van-popup>

    <van-popup v-model="showStartDatePicker" position="bottom">
      <van-datetime-picker 
        :min-date="minDate" 
        :max-date="maxDate" 
        v-model="startDate" 
        type="date" 
        @cancel="showStartDatePicker = false"
        @confirm="onConfirmStartDate" 
      />
    </van-popup>

    <van-popup v-model="showEndDatePicker" position="bottom">
      <van-datetime-picker 
        :min-date="minDate" 
        :max-date="maxDate" 
        v-model="endDate" 
        type="date" 
        @cancel="showEndDatePicker = false"
        @confirm="onConfirmEndDate" 
      />
    </van-popup>

    <van-popup v-model="showStartDatePicker2" position="bottom">
      <van-datetime-picker 
        :min-date="minDate" 
        :max-date="maxDate" 
        v-model="startDate2" 
        type="date" 
        @cancel="showStartDatePicker2 = false"
        @confirm="onConfirmStartDate2" 
      />
    </van-popup>

    <van-popup v-model="showEndDatePicker2" position="bottom">
      <van-datetime-picker 
        :min-date="minDate" 
        :max-date="maxDate" 
        v-model="endDate2" 
        type="date" 
        @cancel="showEndDatePicker2 = false"
        @confirm="onConfirmEndDate2" 
      />
    </van-popup>
	
	<van-popup v-model="aiShowStartDatePicker" position="bottom">
	  <van-datetime-picker 
	    :min-date="minDate" 
	    :max-date="maxDate" 
	    v-model="aiStartDate" 
	    type="date" 
	    @cancel="aiShowStartDatePicker = false"
	    @confirm="onConfirmAIChatStartDate" 
	  />
	</van-popup>
	
	<van-popup v-model="aiShowEndDatePicker" position="bottom">
	  <van-datetime-picker 
	    :min-date="minDate" 
	    :max-date="maxDate" 
	    v-model="aiEndDate" 
	    type="date" 
	    @cancel="aiShowEndDatePicker = false"
	    @confirm="onConfirmAIChatEndDate" 
	  />
	</van-popup>
	
	<van-popup v-model="showPosterStartDatePicker" position="bottom">
	  <van-datetime-picker 
	    :min-date="minDate" 
	    :max-date="maxDate" 
	    v-model="posterStartDate" 
	    type="date" 
	    @cancel="showPosterStartDatePicker = false"
	    @confirm="onConfirmPosterStartDate" 
	  />
	</van-popup>
	<van-popup v-model="showPosterEndDatePicker" position="bottom">
	  <van-datetime-picker 
	    :min-date="minDate" 
	    :max-date="maxDate" 
	    v-model="posterEndDate" 
	    type="date" 
	    @cancel="showPosterEndDatePicker = false"
	    @confirm="onConfirmPosterEndDate" 
	  />
	</van-popup>
  </div>
</template>

<script>
import { Empty } from 'vant'; 
export default {
  name: 'HospitalStats',
  components: {
    'van-empty': Empty  // 局部注册
  },
  data() {
    return {
      showLoading: false,
      // 今日统计数据
      todayScreenTotal: 0,
      todayFileTotal: 0,
      // 查询相关
      selectedDate: '', // 显示在输入框中的日期
      showDatePicker: false, // 控制日期选择器显示
      currentDate: new Date(), // 日期选择器当前选中值
      minDate: new Date('2020-01-01'), // 最小可选日期
      maxDate: new Date(), // 最大可选日期为今天

      selectStartDate: '',
      selectEndDate: '',
      startDate: '',
      endDate: '',
      showStartDatePicker: false,
      showEndDatePicker: false,

      selectStartDate2: '',
      selectEndDate2: '',
      startDate2: '',
      endDate2: '',
      showStartDatePicker2: false,
      showEndDatePicker2: false,
	  
	  aiSelectStartDate: '',
	  aiSelectEndDate: '',
	  aiStartDate: '',
	  aiEndDate: '',
	  aiShowStartDatePicker: false,
	  aiShowEndDatePicker: false,
	  

      // 医院搜索相关
      allHospitals: [], // 存储全部医院数据
      filteredHospitals: [], // 存储过滤后的医院数据
      hospitalSearchKey: '', // 搜索关键词
      showHospitalPopup: false,
      selectedHospital: '', // 选中的医院值
      selectedHospitalName: '', // 选中的医院名称
      loading: false,
      finished: false,
      page: 1,
      pageSize: 20,
      hospitalOptions: [
        { label: '北京协和医院', value: 'pku' },
        { label: '上海瑞金医院', value: 'shanghai' },
        // 可扩展更多医院
      ],
      schoolScreenCount: '--',
      hospitalFileCount: '--',
      orderAmount: '--',
      orderCount: '--',
      // Tab 相关
      tabs: [
        { key: 'school', title: '入校筛查量排名' },
        { key: 'hospital', title: '医院建档量排名' },
		    { key: 'aiChat', title: 'AI咨询量排名' },
        { key: 'orderCount', title: '订单数量排名' },
        { key: 'orderAmount', title: '订单金额排名' },
      ],
      currentTab: 'school',
      // 模拟排名数据
      schoolRankList: [
      ],
      hospitalRankList: [
      ],
	  aiChatRankList: [],
      orderCountRankList: [],
      orderAmountRankList: [],
      // 加载状态
      loadingSchool: false,
      loadingHospital: false,
	  loadingAIChat: false,
      loadingOrderCount: false,
      loadingOrderAmount: false,
      // 分页控制
      showAllSchool: false,
      showAllHospital: false,
	  showAllAIChat: false,
      showAllOrderCount: false,
      showAllOrderAmount: false,
      initialLimit: 15, // 初始显示数量
      schoolSearchKey: '', // 搜索相关
      hospitalSearchKey2: '',
	  aiSearchKey: '',
      orderCountSearchKey: '',
      orderAmountSearchKey: '',
      filteredSchoolList: [],
      filteredHospitalList: [],
	  filteredAIChatList: [],
      filteredOrderCountList: [],
      filteredOrderAmountList: [],
	  // 海报
	  posterStartDate: '',
	  posterEndDate: '',
	  selectPosterStartDate: '',
	  selectPosterEndDate: '',
	  posterSearchKey: '',
	  showPosterStartDatePicker: false,
	  showPosterEndDatePicker: false,
	  posterOffset: 0,
	  posterUseStatisticList: [],
	  loadingPoster: false,
	  showAllPoster: false,
	  dimensionSelectedOption: '0',
	  
    };
  },
  watch: {
    // 监听数据变化，初始化过滤结果
    schoolRankList: {
      handler() {
        this.filteredSchoolList = [...this.schoolRankList];
      },
      immediate: true
    },
    hospitalRankList: {
      handler() {
        this.filteredHospitalList = [...this.hospitalRankList];
      },
      immediate: true
    },
    aiChatRankList: {
      handler() {
        this.filteredAIChatList = [...this.aiChatRankList];
      },
      immediate: true
    },
    orderCountRankList: {
      handler() {
        this.filteredOrderCountList = [...this.orderCountRankList];
      },
      immediate: true
    },
    orderAmountRankList: {
      handler() {
        this.filteredOrderAmountList = [...this.orderAmountRankList];
      },
      immediate: true
    }
  },
  created() {
    // 初始化选中日期为今天
    // this.selectedDate = this.formatDate(new Date());
    this.selectStartDate = this.formatDate(new Date());
    this.selectEndDate = this.formatDate(new Date());
    this.startDate = new Date();
    this.endDate = new Date();

    this.selectStartDate2 = this.formatDate(new Date());
    this.selectEndDate2 = this.formatDate(new Date());
    this.startDate2 = new Date();
    this.endDate2 = new Date();
    this.selectPosterStartDate = this.formatDate(new Date());
	this.selectPosterEndDate = this.formatDate(new Date());
	let nowDate = new Date();
    this.posterStartDate = nowDate;
	this.posterEndDate = nowDate;
	this.aiStartDate = nowDate;
	this.aiEndDate = nowDate;
	this.aiSelectStartDate = this.formatDate(nowDate);
	this.aiSelectEndDate = this.formatDate(nowDate);
    // 加载全部医院数据
    this.loadAllHospitals();
    this.loadTodayData();
    // 初始加载学校数据
    this.switchTab('school');
	this.handlePosterSearch(false);
  },
  computed: {
    // 计算属性：根据当前状态返回要显示的学校列表
    displaySchoolList() {
      if (this.showAllSchool || this.schoolRankList.length <= this.initialLimit) {
        return this.schoolRankList;
      }
      return this.schoolRankList.slice(0, this.initialLimit);
    },
    
    // 计算属性：根据当前状态返回要显示的医院列表
    displayHospitalList() {
      if (this.showAllHospital || this.hospitalRankList.length <= this.initialLimit) {
        return this.hospitalRankList;
      }
      return this.hospitalRankList.slice(0, this.initialLimit);
    },
	 displayAIChatList() {
		  if (this.showAllAIChat || this.aiChatRankList.length <= this.initialLimit) {
			return this.aiChatRankList;
		  }
		  return this.aiChatRankList.slice(0, this.initialLimit);
		},
    displayOrderCountList() {
      if (this.showAllOrderCount || this.orderCountRankList.length <= this.initialLimit) {
        return this.orderCountRankList;
      }
      return this.orderCountRankList.slice(0, this.initialLimit);
    },
    displayOrderAmountList() {
      if (this.showAllOrderAmount || this.orderAmountRankList.length <= this.initialLimit) {
        return this.orderAmountRankList;
      }
      return this.orderAmountRankList.slice(0, this.initialLimit);
    },
    // 新增：处理过滤后的学校列表分页
    displayFilteredSchoolList() {
      // 如果没有搜索关键词，直接用原分页逻辑
      if (!this.schoolSearchKey) {
        return this.displaySchoolList;
      }
      // 有搜索关键词时，对过滤后的列表进行分页
      if (this.showAllSchool || this.filteredSchoolList.length <= this.initialLimit) {
        return this.filteredSchoolList;
      }
      return this.filteredSchoolList.slice(0, this.initialLimit);
    },

    // 新增：处理过滤后的医院列表分页
    displayFilteredHospitalList() {
      // 如果没有搜索关键词，直接用原分页逻辑
      if (!this.hospitalSearchKey2) {
        return this.displayHospitalList;
      }
      // 有搜索关键词时，对过滤后的列表进行分页
      if (this.showAllHospital || this.filteredHospitalList.length <= this.initialLimit) {
        return this.filteredHospitalList;
      }
      return this.filteredHospitalList.slice(0, this.initialLimit);
    }
	,
	displayFilteredAIChatList() {
	  // 如果没有搜索关键词，直接用原分页逻辑
	  if (!this.aiSearchKey) {
	    return this.displayAIChatList;
	  }
	  // 有搜索关键词时，对过滤后的列表进行分页
	  if (this.showAllAIChat || this.filteredAIChatList.length <= this.initialLimit) {
	    return this.filteredAIChatList;
	  }
	  return this.filteredAIChatList.slice(0, this.initialLimit);
	},
    displayFilteredOrderCountList() {
      if (!this.orderCountSearchKey) {
        return this.displayOrderCountList;
      }
      if (this.showAllOrderCount || this.filteredOrderCountList.length <= this.initialLimit) {
        return this.filteredOrderCountList;
      }
      return this.filteredOrderCountList.slice(0, this.initialLimit);
    },
    displayFilteredOrderAmountList() {
      if (!this.orderAmountSearchKey) {
        return this.displayOrderAmountList;
      }
      if (this.showAllOrderAmount || this.filteredOrderAmountList.length <= this.initialLimit) {
        return this.filteredOrderAmountList;
      }
      return this.filteredOrderAmountList.slice(0, this.initialLimit);
    }
  },
  methods: {
	  async handleDimensionSelectChange () {
		  await this.loadTabData();
		  await this.filterHospitalList();
	  },
    handleHospitalChange() {
      // 切换医院时可做的逻辑，比如清空之前查询结果
      this.schoolScreenCount = '--';
      this.hospitalFileCount = '--';
    },
    // 格式化日期为 YYYY-MM-DD
    formatDate(date) {
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return `${year}-${month}-${day}`;
    },

    switchTab(tabKey) {
      this.currentTab = tabKey;
      // 否则加载新数据
      this.loadTabData(tabKey);
    },

    // 加载 Tab 数据
    async loadTabData() {
      let tabKey = this.currentTab;
      let auth = this.$createAuth(this.$md5);
      let requestParam = {
          auth: auth.code,
          time: auth.time,
          checkStartDate: this.selectStartDate2,
          checkEndDate: this.selectEndDate2,
      }
       this.showLoading = true;
      if (tabKey === 'school') {
       
        this.loadingSchool = true;
        try {
          requestParam.type = 1;
		  requestParam.dimension = 0;
          let result = await this.$http.get(this.$url.getHospitalDataRank, requestParam);
          console.log(result)
          this.schoolRankList = result.data.hospitalRank;
        } catch (error) {
          console.error('加载学校排名数据失败:', error);
          this.$toast('加载数据失败，请重试');
        } finally {
          this.showAllSchool = false;
          this.showLoading = false;
          this.loadingSchool = false;
        }
      } else if (tabKey === 'hospital') {
        this.loadingHospital = true;
        try {
          requestParam.type = 2;
		  requestParam.dimension = this.dimensionSelectedOption;
          let result = await this.$http.get(this.$url.getHospitalDataRank, requestParam);
          console.log(result)
          this.hospitalRankList = result.data.hospitalRank;
        } catch (error) {
          console.error('加载医院排名数据失败:', error);
          this.$toast('加载数据失败，请重试');
        } finally {
          this.showAllHospital = false;
          this.showLoading = false;
          this.loadingHospital = false;
          console.log('打印--'+this.loadingHospital)
        }
      }else if (tabKey === 'aiChat') {
        this.loadingAIChat = true;
        try {
			let result = await this.$http.get(this.$url.getAIChatUseStatistic, requestParam);
			this.aiChatRankList = result.result;
			
        } catch (error) {
          console.error('加载AI咨询排名数据失败:', error);
          this.$toast('加载数据失败，请重试');
        } finally {
          this.showAllAIChat = false;
          this.showLoading = false;
          this.loadingAIChat = false;
          console.log('打印--'+this.loadingAIChat)
        }
      } else if (tabKey === 'orderCount') {
        this.loadingOrderCount = true;
        try {
          requestParam.type = 3;
          let result = await this.$http.get(this.$url.getHospitalOrderCountStatistics, requestParam);
          this.orderCountRankList = result.result || [];
        } catch (error) {
          console.error('加载订单数量排名数据失败:', error);
          this.$toast('加载数据失败，请重试');
        } finally {
          this.showAllOrderCount = false;
          this.showLoading = false;
          this.loadingOrderCount = false;
        }
      } else if (tabKey === 'orderAmount') {
        this.loadingOrderAmount = true;
        try {
          requestParam.type = 4;
          let result = await this.$http.get(this.$url.getHospitalOrderStatistics, requestParam);
          this.orderAmountRankList = result.result || [];
        } catch (error) {
          console.error('加载订单金额排名数据失败:', error);
          this.$toast('加载数据失败，请重试');
        } finally {
          this.showAllOrderAmount = false;
          this.showLoading = false;
          this.loadingOrderAmount = false;
        }
      }
    },

    // 过滤学校列表
    filterSchoolList() {

      if (!this.schoolSearchKey) {
        this.filteredSchoolList = [...this.schoolRankList];
        return;
      }
       this.filteredSchoolList = [];
      const key = this.schoolSearchKey.toLowerCase();
      this.filteredSchoolList = this.schoolRankList.filter(school => 
        school.name.toLowerCase().includes(key)
      );
      
      // 重置分页状态
      this.showAllSchool = false;
    },
    
    // 过滤医院列表
    async filterHospitalList() {
      if (!this.hospitalSearchKey2) {
        this.filteredHospitalList = [...this.hospitalRankList];
        return;
      }
      this.filteredHospitalList = []
      const key = this.hospitalSearchKey2.toLowerCase();
      this.filteredHospitalList = this.hospitalRankList.filter(hospital => 
        hospital.name.toLowerCase().includes(key)
      );
      
      // 重置分页状态
      this.showAllHospital = false;
    },
	clearAISearchKey(){
		this.aiSearchKey = "";
	},
    filterAIChatList() {
      if (!this.aiSearchKey) {
        this.filteredAIChatList = [...this.aiChatRankList];
        return;
      }
      this.filteredAIChatList = []
      const key = this.aiSearchKey.toLowerCase();
	  if(this.aiChatRankList.length > 0){
		  this.filteredAIChatList = this.aiChatRankList.filter(aichat =>
		    aichat.name.toLowerCase().includes(key)
		  );
	  }
      
      // 重置分页状态
      this.showAllAIChat = false;
    },
    // 加载全部学校数据
    loadAllSchoolData() {
      this.showAllSchool = true;
    },
    
    // 加载全部医院数据
    loadAllHospitalData() {
      this.showAllHospital = true;
    },
	loadAllAIChatData(){
		this.showAllAIChat = true;
	},
    loadAllOrderCountData() {
      this.showAllOrderCount = true;
    },
    loadAllOrderAmountData() {
      this.showAllOrderAmount = true;
    },
    filterOrderCountList() {
      if (!this.orderCountSearchKey) {
        this.filteredOrderCountList = [...this.orderCountRankList];
        return;
      }
      this.filteredOrderCountList = [];
      const key = this.orderCountSearchKey.toLowerCase();
      this.filteredOrderCountList = this.orderCountRankList.filter(item => 
        item.name.toLowerCase().includes(key)
      );
      this.showAllOrderCount = false;
    },
    filterOrderAmountList() {
      if (!this.orderAmountSearchKey) {
        this.filteredOrderAmountList = [...this.orderAmountRankList];
        return;
      }
      this.filteredOrderAmountList = [];
      const key = this.orderAmountSearchKey.toLowerCase();
      this.filteredOrderAmountList = this.orderAmountRankList.filter(item => 
        item.name.toLowerCase().includes(key)
      );
      this.showAllOrderAmount = false;
    },
    // 日期选择确认回调
    onConfirmDate(date) {
      this.selectedDate = this.formatDate(date);
      this.currentDate = date;
      this.showDatePicker = false;
      
      // 清空之前的查询结果
      this.schoolScreenCount = '--';
      this.hospitalFileCount = '--';
      this.orderAmount = '--';
      this.orderCount = '--';
    },

    // 日期选择确认回调
    onConfirmStartDate(date) {
      debugger
      this.selectStartDate = this.formatDate(date);
      this.startDate = date;
      this.showStartDatePicker = false;
      
      // 清空之前的查询结果
      this.schoolScreenCount = '--';
      this.hospitalFileCount = '--';
      this.orderAmount = '--';
      this.orderCount = '--';
    },

    // 日期选择确认回调
    onConfirmEndDate(date) {
      this.selectEndDate = this.formatDate(date);
      this.endDate = date;
      this.showEndDatePicker = false;
      
      // 清空之前的查询结果
      this.schoolScreenCount = '--';
      this.hospitalFileCount = '--';
      this.orderAmount = '--';
      this.orderCount = '--';
    },

    // 日期选择确认回调
    onConfirmStartDate2(date) {
      debugger
      this.selectStartDate2 = this.formatDate(date);
      this.startDate2 = date;
      this.showStartDatePicker2 = false;
    },

    // 日期选择确认回调
    onConfirmEndDate2(date) {
      this.selectEndDate2 = this.formatDate(date);
      this.endDate2 = date;
      this.showEndDatePicker2 = false;
    },
	
	onConfirmPosterStartDate(date) {
		this.selectPosterStartDate = this.formatDate(date);
		this.showPosterStartDatePicker = false;
	},
	
	onConfirmPosterEndDate(date) {
		this.selectPosterEndDate = this.formatDate(date);
		this.showPosterEndDatePicker = false;
	},
    
	
	onConfirmAIChatStartDate(date) {
		this.aiSelectStartDate = this.formatDate(date);
		this.aiShowStartDatePicker = false;
	},
	
	onConfirmAIChatEndDate(date) {
		this.aiSelectEndDate = this.formatDate(date);
		this.aiShowEndDatePicker = false;
	},
	
    async handleSearch() {
        if (!this.selectStartDate || !this.selectEndDate || !this.selectedHospital) {
            this.$toast('请选择日期和医院');
            return;
        }
      try {
        let auth = this.$createAuth(this.$md5);
        this.showLoading = true;
        let result = await this.$http.get(this.$url.getHospitalDataDetail, {
            auth: auth.code,
            time: auth.time,
            checkStartDate: this.selectStartDate,
            checkEndDate: this.selectEndDate,
            hospitalId: this.selectedHospital,
        });
        console.log(result)
         this.showLoading = false;
        this.schoolScreenCount = result.data.dataDetail.school;
        this.hospitalFileCount = result.data.dataDetail.hospital;
        
        let orderResult = await this.$http.get(this.$url.getHospitalOrderStatistics, {
            checkStartDate: this.selectStartDate,
            checkEndDate: this.selectEndDate,
            hospitalId: this.selectedHospital,
        });
        this.orderAmount = orderResult.result?.[0].totalNumber || 0;
        let orderCountResult = await this.$http.get(this.$url.getHospitalOrderCountStatistics, {
            checkStartDate: this.selectStartDate,
            checkEndDate: this.selectEndDate,
            hospitalId: this.selectedHospital,
        });
        this.orderCount = orderCountResult.result?.[0].totalNumber || 0;
      } catch (error) {
        console.error('加载今日平台数据失败:', error);
        this.showLoading = false;
      }
    },
		
	async handlePosterSearch(more) {
		if (!this.selectPosterStartDate || !this.selectPosterEndDate) {
			this.$toast('请选择日期');
			return;
		}
		if(!more){
			this.posterOffset = 0;
			this.showAllPoster = false;
		}
		try {
			this.showLoading = true;
			let endDate = this.posterEndDate;
			endDate.setDate(endDate.getDate() + 1);
			const selectEndDate = this.formatDate(endDate);
			let result = await this.$http.post("https://shop.yjkok.com/"+this.$url.getPosterUseStatistic + "?startDate=" + this
				.selectPosterStartDate +
				"&endDate=" + selectEndDate +"&offset="+ this.posterOffset, {},
				{
					headers: {
						"tenant-id": 166
					}
				}

			);
			console.log(result)
			this.showLoading = false;
			
			if(result.code == 0){
				this.posterUseStatisticList = result.data;
				if(!result.data){
					this.showAllPoster = true;
					return
				}
				if(result.data.length < 10){
					this.showAllPoster = true;
				}
				return this.posterUseStatisticList;
			}else {
				return [];
			}
			
			// this.schoolScreenCount = result.data.dataDetail.school;
			// this.hospitalFileCount = result.data.dataDetail.hospital;
		} catch (error) {
			console.error('加载海报数据失败:', error);
		}
	},
	// 加载更多数据
	async loadMorePosterData() {
		if(this.loadingPoster){
			return;
		}
		this.loadingPoster = true;
		const posterList = this.posterUseStatisticList;
		this.posterOffset += 10;
		const morePosterList = await this.handlePosterSearch(true);
		if(morePosterList && morePosterList.length < 10){
		  this.showAllPoster = true;
		}
		this.posterUseStatisticList = [...posterList, ...this.posterUseStatisticList];;
	  
		this.loadingPoster = false;
	  
	},
    // 加载今日平台数据
    async loadTodayData() {
      try {
        let auth = this.$createAuth(this.$md5);
        let result = await this.$http.get(this.$url.getTodayData, {
            auth: auth.code,
            time: auth.time,
        });
        console.log(result)
        this.todayScreenTotal = result.data.todayData.school;
        this.todayFileTotal = result.data.todayData.hospital;
      } catch (error) {
        console.error('加载今日平台数据失败:', error);
      }
    },
    // 加载全部医院数据
    async loadAllHospitals() {
      try {
        let auth = this.$createAuth(this.$md5);
        let result = await this.$http.get(this.$url.getHospitalAll, {
            auth: auth.code,
            time: auth.time,
        });
        console.log(result)
        this.allHospitals = result.data.hospitalAll
        this.filteredHospitals = [...this.allHospitals];
      } catch (error) {
        console.error('加载医院数据失败:', error);
      }
    },
    // 筛选医院列表
    filterHospitals() {
      this.page = 1;
      this.finished = false;
      
      if (!this.hospitalSearchKey) {
        // 无搜索关键词时重置为全部数据
        this.filteredHospitals = [...this.allHospitals];
        return;
      }
      
      // 根据关键词筛选
      const key = this.hospitalSearchKey.toLowerCase();
      this.filteredHospitals = this.allHospitals.filter(hospital => 
        hospital.label.toLowerCase().includes(key)
      );
    },

    // 加载更多医院（分页）
    loadMoreHospitals() {
      if (this.filteredHospitals.length >= this.allHospitals.length) {
        this.finished = true;
        return;
      }
      
      this.page++;
      const start = (this.page - 1) * this.pageSize;
      const end = this.page * this.pageSize;
      
      // 模拟分页加载
      setTimeout(() => {
        this.filteredHospitals = [
          ...this.filteredHospitals,
          ...this.allHospitals.slice(start, end)
        ];
        this.loading = false;
      }, 300);
    },
    
    // 选择医院
    selectHospital(hospital) {
      this.selectedHospital = hospital.value;
      this.selectedHospitalName = hospital.label;
      this.hospitalSearchKey = '';
      this.showHospitalPopup = false;
      console.log(hospital)
      // 清空之前的查询结果
      this.schoolScreenCount = '--';
      this.hospitalFileCount = '--';
      this.orderAmount = '--';
      this.orderCount = '--';
    },
    
    // 高亮搜索关键词
    highlightKeyword(text) {
      if (!this.hospitalSearchKey) return text;
      
      const key = this.hospitalSearchKey.toLowerCase();
      const index = text.toLowerCase().indexOf(key);
      
      if (index === -1) return text;
      
      return (
        <span>
          {text.substring(0, index)}
          <span style="color: #007bff; font-weight: bold;">
            {text.substring(index, index + key.length)}
          </span>
          {text.substring(index + key.length)}
        </span>
      );
    },
    
  },
};
</script>
<style>
.van-button {
  border-radius: 8px !important;
}
.van-search__content {
  border-radius: 8px !important;
}

</style>
<style scoped>
.loading-mask {
  position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    display: flex
;
    justify-content: center;
    align-items: center;
    z-index: 100;
    margin: 0;
}
.hospital-stats-page {
  padding: 10px;
  background-color: #f1f1f1;
  min-height: 100vh;
  box-sizing: border-box;
}
.section-b {
  margin-bottom: 10px;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
}

.section-data {
  margin-bottom: 10px;
  padding: 10px 0px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
}

/* 今日统计区 */
.top-stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 10px;
}

.stat-card {
  flex: 1;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  background-color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.card-icon {
  font-size: 24px;
  color: #007bff;
  margin-bottom: 10px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

/* 查询区 */
.search-section {
  margin-bottom: 20px;
}

/* .date-picker {
  position: relative; 
  width: 86%; 
  background-color: transparent;
}

.input-common {
  width: 100%;
  padding: 8px 12px;
  padding-right: 36px; 
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.date-input {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23666' viewBox='0 0 16 16'%3E%3Cpath d='M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z'/%3E%3Cpath d='M5.5 10a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5zm-1-4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm-6 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center; 
  background-size: 16px 16px; 
}


.date-input {
  pointer-events: auto;
} */
 /* 日期选择器组容器 - 横向排列 */
.date-picker-group {
  display: flex;
  align-items: center;
  gap: 12px; /* 两个输入框之间的间距 */
  width: 100%; /* 占满父容器宽度 */
}

/* 单个日期选择器项 */
.date-picker-item {
  flex: 1; /* 两个输入框平分宽度 */
}

/* 分隔符样式 */
.date-separator {
  color: #999; /* 灰色文字 */
  font-size: 14px;
  white-space: nowrap; /* 防止换行 */
}

/* 保持原有的输入框样式 */
.input-common {
  width: 100%;
  padding: 8px 12px;
  padding-right: 36px; /* 预留图标空间 */
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  box-sizing: border-box; /* 确保padding不影响总宽度 */
  border-radius: 8px;
}

.input-common-min {
  width: 100%;
  padding: 8px 12px;
  padding-right: 36px; /* 预留图标空间 */
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  box-sizing: border-box; /* 确保padding不影响总宽度 */
  border-radius: 8px;
}

.date-input {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23666' viewBox='0 0 16 16'%3E%3Cpath d='M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z'/%3E%3Cpath d='M5.5 10a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5zm-1-4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm-6 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px 16px;
}

.search-button {
  background-color: #5CC4AB;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.search-button:hover {
  background-color: #5CC4AB;
}


.hospital-select{
  margin-bottom: 10px;
  display: flex;
}
.stats-result {
  margin-bottom: 10px;
}
select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.search-btn {
  width: 100%;
  height: 35px;
  line-height: 35px;
  /* padding: 10px; */
  background-color: #5CC4AB;
  color: #fff;
  border: none;
  border-radius: 8px;
  text-align: center;
  font-size: 14px;
  padding: 0 20px;
}

.search-header {
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 10px;
  box-sizing: border-box;
  /* 可以添加背景色让头部与内容区分开 */
  background-color: #fff;
  border-bottom: 1px solid #eee;
}
.hospital-search-van {
  flex: 1;
  /* 调整搜索框高度 */
  --van-search-input-height: 40px;
  border-radius: 8px;
}

.cancel-btn-van {
  height: 34px;
  padding: 0 16px;
  font-size: 14px;
  /* border-radius: 8px; */
  /* 确保按钮文字颜色与整体风格协调 */
  color: #666;
      line-height: 1.1;
}

.hospital-list {
  /* 计算高度，减去头部高度和内边距 */
  height: calc(100% - 60px);
  overflow-y: auto;
  padding: 0 10px;
  box-sizing: border-box;
}

/* Tab 栏 */
.tab-bar {
  display: flex;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}
.tab-item {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  color: #333;
}
.tab-item.active {
  color: #5CC4AB;
  border-bottom: 2px solid #5CC4AB;
}

/* Tab 内容区 */
/* .tab-content {
  padding: 10px;
} */
.rank-list {
  list-style: none;
  padding: 0;
}
.rank-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}
.rank {
  display: inline-block;
  width: 6%;
  text-align: center;
  /* color: #fff; */
  /* background-color: #007bff; */

  /* padding: 2px; */
  display: flex;
  align-content: center;
  justify-content: center;
}
.rank-icon {
  width: 20px;
  height: 20px;
  line-height: 22px;
  text-align: center;
  font-size: 12px;
  border-radius: 50%;
}

/* 前三位排名样式 */
.top-three {
  background-color: #5CC4AB; /* 绿色背景 */
  color: white;
}

/* 其他排名样式 */
.normal {
  background-color: #ddd; /* 灰色背景 */
}

.result-boxes {
  display: flex;
  gap: 10px;
  margin: 10px 0;
}

.result-box {
  flex: 1;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.school-box {
  border: 1px;
  /* background-color: rgba(0, 123, 255, 0.05); */
}

.hospital-box {
  border: 1px;
  /* background-color: rgba(40, 167, 69, 0.05); */
}

.box-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.box-value {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.van-loading {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.rank-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 2px solid #ddd;
  font-weight: bold;
}

.rank-header .rank {
  min-width: 9%;
  width: 10%;
  /* margin-right: 10px; */
  text-align: center;
}

.rank-header .name {
  width: 54%;
  /* padding-left: 10px; */
  flex-wrap: wrap;
}

.rank-header .userCount {
  min-width: 9%;
  width: 20%;
  text-align: center;
}

.rank-header .number {
  width: 27%;
  text-align: right;
  /* padding-right: 10px; */
}

.rank-item .name {
  width: 62%;
  flex-wrap: wrap;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: left;
}

.rank-item .userCount {
	width: 20%;
	flex-wrap: wrap;
	padding: 0 4px;
	box-sizing: border-box;
	text-align: center;
}
.rank-item .number {
   width: 25%;
  text-align: right;
  /* padding-right: 10px; */
}
</style>